import { DateTime as DT } from 'luxon';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'context/SettingsContext';
import { TaskStatusBadge, TaskTypeChip, formatTaskPayAmount } from 'modules/task';
import type { TaskPayReportItemType } from '@econtractor/types';
import { tDirName } from 'utils/helpers/i18n/tDirName';
import { formatTaskBinding } from '../../model';

interface TaskPayRowsTableRowProps {
    row: TaskPayReportItemType;
}

const TaskPayRowsTableRow = ({ row }: TaskPayRowsTableRowProps) => {
    const { t } = useTranslation(['Reports', 'Tasks']);
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const date = DT.fromMillis(row.dateEnd || 0);
    const amount = row.pay ? Number(row.payAmount) || 0 : 0;
    const binding = formatTaskBinding(row, t);

    return (
        <tr>
            <td className="name">
                <h6 className="mb-0 text-break">{row.taskName || '—'}</h6>
            </td>
            <td className="type">
                <TaskTypeChip
                    name={tDirName(t, row.taskTypeI18nKey, row.taskTypeName)}
                    icon={row.taskTypeIcon}
                    colors={row.taslTypeJson}
                    fontSize="0.7rem"
                />
            </td>
            <td className="status">
                <TaskStatusBadge status={Number(row.taskStatus)} dateEnd={row.dateEnd} />
            </td>
            <td className="date">{date.isValid ? date.toFormat('dd.MM.yyyy') : '—'}</td>
            <td className="binding">
                <div className="text-muted f-12">{binding.kind}</div>
                {binding.name ? <div className="text-break">{binding.name}</div> : null}
            </td>
            <td className="income text-end">
                <h6 className="mb-0 text-break">
                    {formatTaskPayAmount(amount, row.pay ? row.payUsd : false, rate)}
                </h6>
            </td>
        </tr>
    );
};

export default TaskPayRowsTableRow;
